/**
 * @file 指導者訓練歴切り替え
 */

'use strict';

/**
 * @classname ChangeLeaderTrainingType
 * @classdesc 指導者訓練歴切り替え
 */
export default class ChangeLeaderTrainingType {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`ChangeLeaderTrainingType.constructor`);
		this._$e = $e;
		$e.on('change', () => this.onChange());
		$(window).on('scroll', () => this.onScroll());
		this._$nameBlock = $('.block-member-name')
		this._$name = `<dl class="dl dl-table">${$('.dl-table').html()}</dl>`;
		console.log(this._$name);
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeLeaderTrainingType
	 * @return {undefined}
	 */
	onChange() {
		console.log(`ChangeLeaderTrainingType.onChange`);
		const target = $(this._$e.val());
		const position = target.offset().top - 223;
		$('html, body').animate({scrollTop: position}, 500, 'swing');
	}


	/**
	 * scrollのコールバック
	 *
	 * @memberof ChangeLeaderTrainingType
	 * @return {undefined}
	 */
	onScroll() {
		console.log(`ChangeLeaderTrainingType.onScroll`);
		const scroll = $(window).scrollTop();
		if(scroll > 180) {
			this._$nameBlock.html(this._$name);
		} else {
			this._$nameBlock.html('');
		}
	}
}
